if (!customElements.get('cf-hb-gallery')) {
  customElements.define('cf-hb-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const main = this.querySelector('.cf-hb-selected');
      const enlarge = this.querySelector('[data-hb-enlarge]');
      const dialog = this.querySelector('dialog');
      this.addEventListener('click', event => {
        const thumb = event.target.closest('[data-hb-image]');
        if (thumb) {
          event.preventDefault();
          main.removeAttribute('srcset');
          main.src = thumb.dataset.src;
          main.alt = thumb.dataset.alt;
          enlarge.href = thumb.href;
          this.querySelectorAll('[data-hb-image]').forEach(link => link.removeAttribute('aria-current'));
          thumb.setAttribute('aria-current', 'true');
        }
        if (event.target.closest('[data-hb-enlarge]') && typeof dialog.showModal === 'function') {
          event.preventDefault();
          const zoomed = dialog.querySelector('img');
          zoomed.removeAttribute('srcset');
          zoomed.src = enlarge.href;
          zoomed.alt = main.alt;
          dialog.showModal();
        }
        if (event.target.closest('[data-hb-close]') || event.target === dialog) dialog.close();
      });
      const section = this.closest('.cf-hb-main');
      section.addEventListener('shopify:cart:error', event => {
        if (event.code !== 'SERVICE_UNAVAILABLE') return;
        const message = section.querySelector('[data-hb-network-error]');
        if (message) message.hidden = false;
      });
      section.querySelector('form')?.addEventListener('submit', () => {
        const message = section.querySelector('[data-hb-network-error]');
        if (message) message.hidden = true;
      });
    }
  });
}

if (!customElements.get('cf-hb-return')) {
  customElements.define('cf-hb-return', class extends HTMLElement {
    connectedCallback() {
      const purchase = this.closest('.cf-hb-main')?.querySelector('.cf-hb-purchase');
      if (!purchase || this.onViewportChange) return;
      this.onViewportChange = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.hidden = purchase.getBoundingClientRect().bottom >= 0;
        });
      };
      window.addEventListener('scroll', this.onViewportChange, { passive: true });
      window.addEventListener('resize', this.onViewportChange);
      this.onViewportChange();
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.onViewportChange);
      window.removeEventListener('resize', this.onViewportChange);
      cancelAnimationFrame(this.frame);
      this.onViewportChange = null;
      this.frame = null;
    }
  });
}
